import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const FinishAndWash = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.finishAndWashList);
	return (
		<>
			<FilterName type="FINISH_AND_WASH" />
			<Checkbox data={data} type="FINISH_AND_WASH" handleSearch={handleSearch} />
		</>
	);
};

export default FinishAndWash;
